import { render } from "./MenuSidebar.vue?vue&type=template&id=d81379c4&scoped=true&lang=html"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"

import "./MenuSidebar.vue?vue&type=style&index=0&id=d81379c4&lang=css&scoped=true"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81379c4"]])

export default __exports__